import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ToggleBlockListPronounced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.64972 3.87657C1.65008 3.49074 2.06878 3.25069 2.40193 3.44531L7.15939 6.22449C7.49003 6.41764 7.48972 6.89555 7.15883 7.08828L2.39618 9.86228C2.06267 10.0565 1.64417 9.81571 1.64453 9.42975L1.64972 3.87657Z"
          fill={color}
        />
        <path opacity="0.6" d="M9.5 4L14.5 4" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M9.5 8H13.5" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M9.5 12H14.5" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default ToggleBlockListPronounced
